import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { apiFetch } from '../utils/api';
import PageHeader, { btnPrimary, btnSecondary, cardClass, inputClass } from '../components/PageHeader';

const InviteAdmin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', name: '' });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await apiFetch('/admin/users', {
        method: 'POST',
        body: JSON.stringify(form),
      });
      if (res.data?.email_sent) {
        toast.success(`Invite email sent to ${res.data.email}`);
      } else {
        toast.success(res.message || 'Invite created');
      }
      navigate('/users');
    } catch (err) {
      toast.error(err.message || 'Failed to send invite');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-xl">
      <PageHeader title="Invite admin" subtitle="They'll receive an email to create their password" />
      <Link to="/users" className="text-sm text-teal-700 mb-4 inline-block">
        ← Admin users
      </Link>

      <form onSubmit={submit} className={`${cardClass} p-6 space-y-4`}>
        <div>
          <label className="block text-sm font-medium mb-1">Email *</label>
          <input
            type="email"
            required
            className={inputClass}
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Name</label>
          <input
            type="text"
            className={inputClass}
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="Optional — they can confirm on signup"
          />
        </div>
        <div className="flex gap-2 pt-2">
          <button type="submit" disabled={submitting} className={btnPrimary}>
            {submitting ? 'Sending…' : 'Send invite email'}
          </button>
          <Link to="/users" className={btnSecondary}>
            Cancel
          </Link>
        </div>
      </form>
    </div>
  );
};

export default InviteAdmin;
